module.exports = __webpack_public_path__ + "img/alipay.933a9d2.png";